export default "__VITE_ASSET__sfYDGStg__"